import { observable, action } from "mobx";
import { Configuracao } from "../../../services";
import { error, success, info } from "../../../utils/MensagemUtil";
import { validarCamposObrigatorios } from "../../../utils/Validate";

class EmpresaStore {
  @observable
  empresa = {
    nome: "",
    cnpj: "",
    cidade: "",
    uf: "",
    endereco: "",
    numero: "",
    bairro: "",
    url_brasao: ""
  };

  @observable
  foto = "";

  @observable
  fetching = false;

  @action.bound
  handleChange = ({ target }) => {
    const { name, value } = target;

    this.empresa[name] = value;
  };

  @action.bound
  async obterEmpresa() {
    try {
      this.fetching = true;

      const result = await Configuracao.obterEmpresaUsuarioLogado();
      if (result && result.erro) {
        return error(result.erro);
      }

      this.empresa = result;
    } finally {
      this.fetching = false;
    }
  }

  @action.bound
  async salvar() {
    try {
      this.fetching = true;

      const erros = this.validarConfiguracoesEmpresa(this.empresa);
      if (erros.length > 0) {
        error(erros);
        return;
      }

      const result = await Configuracao.atualizarEmpresa(this.toEmpresa());
      if (result.erro) {
        return error(result.erro);
      }

      success("Empresa atualizada com sucesso!");
    } finally {
      this.fetching = false;
    }
  }

  validarConfiguracoesEmpresa = registro => {
    const erros = validarCamposObrigatorios()
      .addSeNuloOuVazio("Nome", registro.nome)
      .addSeNuloOuVazio("CNPJ", registro.cnpj)
      .addSeNuloOuVazio("Cidade", registro.cidade)
      .addSeNuloOuVazio("UF", registro.uf)
      .build();

    return erros;
  };

  @action.bound
  selecionarImagem(files) {
    if (files) {
      this.foto = files[0];
    } else {
      this.foto = "";
    }
  }

  @action.bound
  removerImagem = () => {
    this.foto = "";

    info("Foto removida com sucesso!");
  };

  toEmpresa() {
    const data = new FormData();
    data.append("id", this.empresa.id);
    data.append("nome", this.empresa.nome);
    data.append("cnpj", this.empresa.cnpj);
    data.append("cidade", this.empresa.cidade);
    data.append("uf", this.empresa.uf);
    data.append("endereco", this.empresa.endereco);
    data.append("numero", this.empresa.numero);
    data.append("bairro", this.empresa.bairro);
    data.append("brasao", this.foto);

    return data;
  }
}

export default new EmpresaStore();



// WEBPACK FOOTER //
// ./src/views/configuracoes/stores/EmpresaStore.js